import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import ConnectLayout from '../ConnectLayout';
import './ErrorPage.scss';
import lang from './ErrorPage.lang.json';

function ConnectErrorPage() {
  return (
    <ConnectLayout>
      <div className="error-page__content">
        <Box className="error-page__welcome">
          <Typography className="error-page__title" variant="h4">
            {lang.title}
          </Typography>

          <Typography className="error-page__sub-title" variant="body1">
            {lang.subtitle}
          </Typography>
        </Box>
      </div>
    </ConnectLayout>
  );
}

export default ConnectErrorPage;
